import { FlightBookingDetailController } from "./flight-booking-detail.controller";

export class FlightBookingDetailComponent {
  controller: any = FlightBookingDetailController;
  templateUrl: any = "/html/flights/success_page";
}

angular.module("BookingApp").component("flightBookingDetailComponent", new FlightBookingDetailComponent());
